import { z } from 'zod';
import type { TFunction } from 'i18next';
import { MFA_IDENTITY_TYPES } from '@/entities/mfa-identity';

const createChangePasswordFormSchema = (t: TFunction) => {
  const minLength = t('authPages.validation.passwordRules.minLength');
  const upperLower = t('authPages.validation.passwordRules.uppercaseLowercase');
  const digit = t('authPages.validation.passwordRules.digit');
  const passwordAllowedChars = t(
    'authPages.validation.passwordRules.specialChars'
  );

  const passwordSchema = z
    .string()
    .refine(
      val => /^[A-Za-z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]+$/.test(val),
      {
        message: passwordAllowedChars,
      }
    )
    .min(10, { message: minLength })
    .refine(val => /[a-z]/.test(val) && /[A-Z]/.test(val), {
      message: upperLower,
    })
    .refine(val => /[0-9]/.test(val), {
      message: digit,
    });

  return z.object({
    password: passwordSchema,
    twoFA: z.object({
      state: z.string(),
      identityType: z.enum([...Object.values(MFA_IDENTITY_TYPES)]),
      code: z.string(),
    }),
  });
};

export { createChangePasswordFormSchema };
